const en = {
    all: 'All',
    mainBranch: 'Main branch',
    branchVersion: 'Branch version',
    recordList: 'Record List',
    add: 'Add',
    versionNum: 'Version number',
    updateDesc: 'Update Explanation',
    file: 'File(.apk)',
    downTips: 'Downloading, please wait.',
    downFailError: 'Download failed, {{error}}',
    addAppRecord: 'Add APP release record',
    plFillInfo: 'Please fill in the information completely!',
    addSuccess:'Added successfully',
    delApk: 'Delete APK',
};

export default en;